/**
 * `INTERACTION_EDITORS` — the single registration point for the interaction sub-forms, mirroring
 * app-student's own registry.
 *
 * `Record<InteractionType, Component>` is exhaustive: not `Partial`, no index signature, so a
 * seventh interaction type fails `pnpm typecheck` until an editor is registered. A `v-if` chain
 * on the type would silently render nothing. `INTERACTION_PREVIEWS` mirrors this file — keep the
 * two shapes identical.
 *
 * Every editor takes the same props (`InteractionEditorProps`), which is what makes one
 * dispatcher legitimate; the two field-less types declare none at all.
 */
import type { Component } from 'vue'
import type { InteractionType } from '../../../../model/assessments/types'

import InteractionMultipleChoice from './InteractionMultipleChoice.vue'
import InteractionFillInBlanks from './InteractionFillInBlanks.vue'
import InteractionDragTheWords from './InteractionDragTheWords.vue'
import InteractionWhiteboard from './InteractionWhiteboard.vue'
import InteractionOpenEnded from './InteractionOpenEnded.vue'
import InteractionAudioResponse from './InteractionAudioResponse.vue'

export const INTERACTION_EDITORS: Record<InteractionType, Component> = {
  multiple_choice: InteractionMultipleChoice,
  fill_in_blanks: InteractionFillInBlanks,
  drag_the_words: InteractionDragTheWords,
  whiteboard: InteractionWhiteboard,
  open_ended: InteractionOpenEnded,
  audio_response: InteractionAudioResponse,
}
